import React from "react";
import {
  SEO,
  Image,
  DynamicForm,
  Section,
  FishermanHeader,
  MarkdownContent,
  OutboundLink,
  FishermanIcon,
  FadeReveal,
  Location,
  HoursOfOperation,
  Map,
} from "@bluefin/components";
import { Grid, Segment, Button } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class ContactPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      npopmcalojbnfhhekpapkpdndcicnfglnpop,
      bookingUrl,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.salonvolo.com/contact/"}
        />
        <Grid
          className={"custom-page-contact custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"cfnhniflcihaeaon"}
            style={{ padding: "0" }}
            columns={1}
          >
            <Grid.Column
              className={"nmkjohmmafjcenog"}
              style={{ padding: "0" }}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <Image
                  className={"image-block"}
                  style={{ minHeight: "500px" }}
                  src={getComponentFiles({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "Image",
                    componentIdentifier: "2b5ee501-08f2-4018-8532-3a78a9698754",
                    numToSelect: 1,
                  })}
                  background={false}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"pdbmfhnpfeapemab"}
            style={{ padding: 16 }}
            textAlign={"center"}
          >
            <Grid.Column
              className={"ipnppinldhmiecpd"}
              style={{ padding: 16 }}
              width={8}
              textAlign={"left"}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={2639}
                  businessInfoId={7787}
                  websiteId={9279}
                  locationId={2860}
                  componentConfigurationId={159019}
                  header={npopmcalojbnfhhekpapkpdndcicnfglnpop.data.header}
                  fields={
                    npopmcalojbnfhhekpapkpdndcicnfglnpop.data.dynamicFormFields
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"ckiofoplbbomeekp"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column
              className={"bangdeicbemcejha"}
              style={{ padding: "0" }}
            >
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <React.Fragment
                  key={"JSON__bd58802b-de67-4b95-92ba-b1ed5b0b3683"}
                >
                  <div className={"contact-page"}>
                    <Section className={"book-now-section"}>
                      <Image
                        background={true}
                        src={
                          "https://fisherman.gumlet.io/public/95f16105-9394-4ba8-96a7-8d7963c7ca96/ANXAkqF-R_QFUm8b0hd7Sv0v_6kECuHJWlvjk1zBDNZlQFzcL3ze-xxzGn8tICEzMcQ4xPNlTpTIvbYTV5l7cGcRAEoqLHNrKRRP.jpeg"
                        }
                      >
                        <FishermanHeader
                          as={"h2"}
                          content={"Book Your Appointment"}
                        />
                        <MarkdownContent
                          className={"book-now-description"}
                          isMarkdown={false}
                          content={
                            "Ready to transform your look? Schedule your appointment with our expert stylists in St. Petersburg today and experience the Salon Volo difference."
                          }
                        />
                        <Button
                          secondary={true}
                          as={OutboundLink}
                          to={bookingUrl.url}
                          event={{
                            action: "Schedule Appointment Intent",
                            category: "Booking",
                          }}
                          icon={<FishermanIcon iconName={"arrow-right"} />}
                          labelPosition={"right"}
                          content={bookingUrl.title}
                        />
                      </Image>
                    </Section>
                    <Section className={"contact-info-section"}>
                      <Grid
                        stackable={true}
                        className={"contact-info-container"}
                      >
                        <Grid.Column width={8} className={"info-column"}>
                          <FadeReveal
                            duration={1250}
                            triggerOnce={true}
                            delay={0}
                          >
                            <Location
                              phone={
                                fishermanBusiness.primaryLocation.phoneNumber
                              }
                              email={fishermanBusiness.primaryLocation.email}
                              address={{
                                zip: fishermanBusiness.primaryLocation.zipCode,
                                city: fishermanBusiness.primaryLocation.city,
                                state: fishermanBusiness.primaryLocation.state,
                                street:
                                  fishermanBusiness.primaryLocation.street,
                              }}
                              businessName={fishermanBusiness.name}
                              showBusinessName={false}
                            />
                            <p children={"Opening Hours:"} />
                            <HoursOfOperation
                              hours={fishermanBusiness.primaryLocation.hours}
                              displayOption={"grouped"}
                              inlineHours={true}
                              truncateLabels={true}
                            />
                          </FadeReveal>
                        </Grid.Column>
                        <Grid.Column width={8} className={"map-column"}>
                          <FadeReveal
                            duration={1250}
                            triggerOnce={true}
                            delay={450}
                          >
                            <Map
                              businessName={fishermanBusiness.name}
                              address={{
                                zip: fishermanBusiness.primaryLocation.zipCode,
                                city: fishermanBusiness.primaryLocation.city,
                                state: fishermanBusiness.primaryLocation.state,
                                street:
                                  fishermanBusiness.primaryLocation.street,
                              }}
                            />
                          </FadeReveal>
                        </Grid.Column>
                      </Grid>
                    </Section>
                  </div>
                </React.Fragment>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      primaryLocation {
        phoneNumber
        email
        zipCode
        city
        state
        street
        hours {
          day
          open
          close
        }
      }
    }
    fishermanBusinessWebsitePage(_id: { eq: 34264 }) {
      title
      seoTitle
      description
      components {
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
        order
        fastId
        componentIdentifier
      }
    }
    npopmcalojbnfhhekpapkpdndcicnfglnpop: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "1b9884f3-06aa-42a5-9879-76c0c186e685" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
      }
    }
    bookingUrl: fishermanBusinessWebsitePage(
      title: { regex: "/Book Now|Make An Appointment/" }
      pageType: { eq: "External" }
    ) {
      url
      title
    }
  }
`;
